import { render } from "./ChannelGraphModal.vue?vue&type=template&id=40c27b63"
import script from "./ChannelGraphModal.vue?vue&type=script&lang=js"
export * from "./ChannelGraphModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__